module.exports = __webpack_public_path__ + "static/media/beautiful-ruins.2bc57714.jpg";